import styled, { css } from 'styled-components'

import EllipsisText from 'Components/EllipsisText'
import AppButton from 'Components/AppButton'
import Flex from 'Components/Flex'
import { BREAK_POINT_SM } from '@CSSVars/variables'
import { SITE_BLACK_COLOR, OUTLINE_COLOR, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'

export const _Container = styled.div`
  margin-bottom: 12px;
  border-radius: 10px;

`
export const boldText = css`
  font-weight: 600;
  line-height: 22px;
  font-size: 16px;
`
export const _Title = styled(EllipsisText)`
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    max-width: 200px;
  }
  @media screen and (max-width: 320px) {
    max-width: 185px;
  }
`

const _CommonButton = styled(AppButton)`
  margin-left: 18px;
  font-size: 14px;
  font-weight: initial;
  pointer-events: visible;
`

export const _SelectAllBtn = styled(_CommonButton)``

export const _ClearAllBtn = styled(_CommonButton)`
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    display: none;
  }
`

export const _SquareCheckBox = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 10px;
  border: ${({ selected }) => (selected ? 'none' : '1px solid grey')};
  margin-right: 24px;
  pointer-events: visible;
  &:hover {
    cursor: pointer;
  }
`
export const _SideSvg = styled.div`
  padding: 0;

  svg {
    fill: ${SITE_BLACK_COLOR};
    transform: rotate(-90deg);
    transition: transform 200ms ease-out;
  }
`
export const _CollapsibleHead = styled(Flex)`
  height: 64px;
  padding: 0 16px;
  background: white;
  border-radius: 10px;
  div {
    ${boldText}
  }
  ${({ collapsibleActive }) => (collapsibleActive && `
    ${_SideSvg} svg {
      transform: rotate(90deg);
      transition: transform 200ms ease-in;
    }
  `)}
    ${({ highLighted }) => (highLighted && `
      background: ${SELECTED_ITEM_BG_COLOR};
      div {
        color: white;
        font-size: 16px;
      }
      ${_SideSvg} svg {
        fill: white;
      }
      ${_SquareCheckBox} {
        background: ${SELECTED_ITEM_BG_COLOR};
        border: 1px solid white;
        path {
          &:first-child {
            fill: white;
          }
        }
      }
    `)}
`


export const _NeighbourhoodText = styled.span`
  margin-left: 4px;
  ${boldText}

`

export const _Separator = styled.span`
  color: ${OUTLINE_COLOR};
`

// to have bigger area for user click
export const _CloseContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  padding: 4px;
  width: 36px;
  height: 36px;
  &:hover {
    cursor: pointer;
  }
`
